import produce from 'immer';
import { AnyAction } from 'redux';
import {
  REQUEST_INFORMATION_REQUEST,
  REQUEST_INFORMATION_SUCCESS,
  REQUEST_INFORMATION_FAILURE,
  REQUEST_INFORMATION_INITIAL,
} from '../../actions';

// タイプを設定
export type RequestInformationStateType = {
  isRequestInformationLoading: boolean;
  isRequestInformationLoaded: boolean;
  requestInformationData: RequestInformationType;
};

type RequestInformationType = {
  result: number;
  request_year_month_list: string[] | null;
  // request_year_month_data: Map<string, TargetYearMonthDataType> | null;
  request_year_month_data: { [key: string]: TargetYearMonthDataType } | null;
};

type TargetYearMonthDataType = {
  confirmed: number;
  target_month: string;

  sub_total_list: RequestInformationSubtotalType[];
  total: number;
};

type RequestInformationSubtotalType = {
  sub_total: number;
  sub_total_name: string;
  tax_rate: number;
  request_information: RequestInformationsPropsType[];
};

type RequestInformationsPropsType = {
  id: number;
  shop_id: number;
  type: number;
  tax_rate: number;

  name: string;
  price: number;
};

// ステイタスを初期化
const initialState: RequestInformationStateType = {
  isRequestInformationLoading: false,
  isRequestInformationLoaded: false,
  requestInformationData: {
    result: -1,
    request_year_month_list: [],
    request_year_month_data: {},
  },
};

// APIの結果によってステイタスが更新される処理
const requestInformationReducer = (state = initialState, action: AnyAction): RequestInformationStateType => {
  return produce(state, (draft) => {
    const dataState = draft;
    switch (action.type) {
      case REQUEST_INFORMATION_REQUEST:
        dataState.isRequestInformationLoading = true;
        dataState.isRequestInformationLoaded = false;
        dataState.requestInformationData.result = -1;
        dataState.requestInformationData.request_year_month_list = [];
        dataState.requestInformationData.request_year_month_data = {};
        break;
      case REQUEST_INFORMATION_SUCCESS:
        dataState.isRequestInformationLoading = false;
        dataState.isRequestInformationLoaded = true;
        dataState.requestInformationData.result = action.res.data.result;
        dataState.requestInformationData.request_year_month_list = action.res.data.request_year_month_list;
        dataState.requestInformationData.request_year_month_data = action.res.data.request_year_month_data;
        break;
      case REQUEST_INFORMATION_FAILURE:
        dataState.isRequestInformationLoading = false;
        dataState.isRequestInformationLoaded = false;
        dataState.requestInformationData.result = -1;
        dataState.requestInformationData.request_year_month_list = [];
        dataState.requestInformationData.request_year_month_data = {};
        break;
      case REQUEST_INFORMATION_INITIAL:
        dataState.isRequestInformationLoading = false;
        dataState.isRequestInformationLoaded = false;
        dataState.requestInformationData.result = -1;
        dataState.requestInformationData.request_year_month_list = [];
        dataState.requestInformationData.request_year_month_data = {};
        break;
      default:
        break;
    }
  });
};

export default requestInformationReducer;
